import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { UiLanguage } from '@/services/ws-companies/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

type UiLanguageLabel = (uiLanguage: UiLanguage) => string;

// The names span the common and the country namespace, so the map holds functions of `t`.
const UI_LANGUAGE_NAMES: Record<UiLanguage, (t: TFunction) => string> = {
  [UiLanguage.DE]: (t) => `${t('common:GERMAN')} (${t('country:CH')})`,
  [UiLanguage.DE_AT]: (t) => `${t('common:GERMAN')} (${t('country:AT')})`,
  [UiLanguage.DE_DE]: (t) => `${t('common:GERMAN')} (${t('country:DE')})`,
  [UiLanguage.EN]: (t) => t('common:ENGLISH'),
  [UiLanguage.FR]: (t) => t('common:FRENCH'),
  [UiLanguage.IT]: (t) => t('common:ITALIAN'),
};

// The name of a UI language in the language the UI shows, a German variant with its country: "German (Austria)". The
// component that calls it re-renders on a language switch, through the useTranslation in here.
export const useUiLanguageLabel = (): UiLanguageLabel => {
  const [t] = useTranslation(['common', 'country']);

  return useCallbackRef<UiLanguageLabel>((uiLanguage) => UI_LANGUAGE_NAMES[uiLanguage](t));
};
